import type { ErrorEvent, EventHint } from "@sentry/nextjs";
import {
  isApiError,
  IGNORED_STATUS_CODES,
  type IgnoredStatusCode,
  isHostAppInjectedError,
  isTransitionAbortedError,
  isAbortError,
  isFirefoxInternalError,
  isThirdPartySentryError,
} from "./lib/utils/errors";

const getEnvironment = () => {
  const domain = process.env.NEXT_PUBLIC_ROOT_DOMAIN;

  if (domain === "godetour.dev" || domain === "www.godetour.dev") {
    return "production";
  }

  if (domain?.includes("preview")) {
    return "preview";
  }

  return "development";
};

export const SHARED_SENTRY_CONFIG = {
  dsn: "https://18ddf9321f7263d26cc663c035c25659@o4509230458929152.ingest.de.sentry.io/4510974944870480",

  enabled:
    process.env.NODE_ENV !== "development" && getEnvironment() !== "development",

  tracesSampleRate: 1.0,

  enableLogs: true,

  environment: getEnvironment(),

  sendDefaultPii: true,
};

export function beforeSend(
  event: ErrorEvent,
  hint: EventHint
): ErrorEvent | null {
  if (isHostAppInjectedError(event)) {
    return null;
  }

  const error = hint?.originalException;

  if (isTransitionAbortedError(error) || isAbortError(error)) {
    return null;
  }

  if (
    typeof window !== "undefined" &&
    (isFirefoxInternalError(error) || isThirdPartySentryError(error, event))
  ) {
    return null;
  }

  if (isApiError(error)) {
    const status = error?.status ?? error?.response?.status;
    if (
      status !== undefined &&
      IGNORED_STATUS_CODES.includes(status as IgnoredStatusCode)
    ) {
      return null;
    }
  }

  return event;
}
